/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetOrdersToUser } from '../models/GetOrdersToUser';
import type { newOrder } from '../models/newOrder';
import type { order } from '../models/order';
import type { SetPriceData } from '../models/SetPriceData';
import type { SetPriceStatus } from '../models/SetPriceStatus';
import type { SetStatusData } from '../models/SetStatusData';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OrderService {
    /**
     * GetOrdersToUser
     * @returns GetOrdersToUser OrdersToUserGot
     * @throws ApiError
     */
    public static getOrdersToUser(): CancelablePromise<GetOrdersToUser> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/orders/to_user',
        });
    }
    /**
     * AddOrder
     * @returns order Заказ
     * @throws ApiError
     */
    public static addOrder({
        requestBody,
    }: {
        /**
         * Данные заказа
         */
        requestBody: newOrder,
    }): CancelablePromise<order> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/order',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * SetPrice
     * @returns SetPriceStatus PriceSet
     * @throws ApiError
     */
    public static setPrice({
        requestBody,
    }: {
        requestBody: SetPriceData,
    }): CancelablePromise<SetPriceStatus> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/order/price',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * SetStatus
     * @returns any StatusSet
     * @throws ApiError
     */
    public static setStatus({
        id,
        requestBody,
    }: {
        /**
         * Order ID
         */
        id: number,
        requestBody: SetStatusData,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/order/status/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
